import Color from 'color';
import { ColorResult } from 'react-color';
import { useMemo, useCallback } from 'react';

function colorResultToString(colorResult: ColorResult): string {
    if (colorResult.rgb?.a !== 1) {
        const { r, g, b, a } = colorResult.rgb;
        return Color({ r, g, b }).alpha(a).toString();
    }

    return colorResult.hex;
}

export function hsl2hsv(hslH, hslS, hslL) {
    const hsv1 = (hslS * (hslL < 50 ? hslL : 100 - hslL)) / 100;
    const hsvS = hsv1 === 0 ? 0 : ((2 * hsv1) / (hslL + hsv1)) * 100;
    const hsvV = hslL + hsv1;
    return { h: hslH, s: hsvS, v: hsvV };
}

export type StringToColorResult = ColorResult & {
    hsv: {
        h: number;
        s: number;
        v: number;
        a?: number;
    };
};

export function stringToColorResult(color: string): StringToColorResult {
    const colorObj = Color(color || '#131416'); // text.primary hex fallback when empty — see .claude/rules/styling.md
    const {
        // @ts-ignore
        color: [r, g, b],
        // @ts-ignore
        valpha
    } = colorObj.rgb();

    const {
        // @ts-ignore
        color: [h, s, l]
    } = colorObj.hsl();

    const {
        // @ts-ignore
        color: [_h, _s, _v]
    } = colorObj.hsv();

    return {
        hex: color,
        hsl: { h, s, l, a: valpha },
        rgb: { r, g, b, a: valpha },
        hsv: { h: _h, s: _s, v: _v, a: valpha }
    };
}

export default function useColorPickerConverter(
    selectedColor: string,
    onChange: (color: string) => void
) {
    const color = useMemo(
        () => stringToColorResult(selectedColor),
        [selectedColor]
    );
    const _onChange = useCallback(
        (colorResult: ColorResult) =>
            onChange(colorResultToString(colorResult)),
        [onChange]
    );

    return {
        color,
        onChange: _onChange
    };
}
